import React, { useState, useEffect } from "react";
import { Table, Tag } from "antd";
import { useAppDispatch, useAppSelector } from "@stores/store";
import { IDataHRIS } from "@typed/HRIS/allHris";
import type { ColumnsType } from "antd/es/table";
import { dateToString } from "@helpers/utils";
import { Link } from "react-router-dom";
import { getLevelRequest } from "@stores/HRIS/Level/LevelSlice";
import Loading from "@components/loading";
const column: ColumnsType<IDataHRIS> = [
  {
    title: "Date",
    key: "date",
    dataIndex: "createdAt",
    render: (createdAt: string) => <div>{dateToString(createdAt)}</div>
  },
  {
    title: "Name",
    key: "name",
    dataIndex: "name"
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description"
  },
  {
    title: "IsActive",
    key: "isactived",
    dataIndex: "isActived",
    onFilter: (value: any, record: IDataHRIS) => record.isActived === value,
    filters: [
      {
        text: "Active",
        value: true
      },
      {
        text: "NoActive",
        value: false
      }
    ],
    render: (active: boolean) => (
      <div>
        {active === true ? <Tag color="success">Active</Tag> : <Tag color="error">NoActive</Tag>}
      </div>
    )
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "_id",
    render: (id: string) => (
      <div>
        <Link to={`/hris/level/${id}`}>Detail</Link>
      </div>
    )
  }
];

const Levels = () => {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state.hrisLevel);
  const Level = useAppSelector((state) =>
    state.hrisLevel?.data.map((item: IDataHRIS) => ({ ...item, key: item._id }))
  );

  useEffect(() => {
    dispatch(getLevelRequest());
  }, []);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Link
            to="/hris/level/add"
            className="py-2 w-full px-2 rounded hover:bg-green-600 hover:text-white bg-green-500 text-white font-semibold"
          >
            Create
          </Link>
          <div className="mt-4">
            <Table columns={column} dataSource={Level} />
          </div>
        </>
      )}
    </>
  );
};

export default Levels;
